var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.1,11.5L1.3,7.7L0,9l5.1,5.1L16,3.2l-1.3-1.3L5.1,11.5z","fill":"currentColor"}));
}

Tick.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Tick;

Tick.default = Tick;
